import { apiClient } from "@/lib/api-client"
import type { SageCompanyRuleDto } from "../dtos/SageCompanyRuleDto"
import type {
  CreateIncreasePeriodRequest,
  IncreasePeriodDto,
} from "../dtos/IncreasePeriodDto"
import type {
  IncreasePeriodSummaryDto,
  OpenToManagersResultDto,
  ReportingLineIssuesDto,
} from "../dtos/ReportingLineDto"

const periodsUrl = (organizationId: string) =>
  `/organizations/${organizationId}/salary-increases/periods`

export async function getCompanyRules(
  organizationId: string,
  companyCode: string,
): Promise<SageCompanyRuleDto[]> {
  const response = await apiClient.get<SageCompanyRuleDto[]>(
    `/organizations/${organizationId}/sage300/company-rules`,
    { params: { companyCode } },
  )
  return response.data
}

export async function createIncreasePeriod(
  organizationId: string,
  request: CreateIncreasePeriodRequest,
): Promise<IncreasePeriodDto> {
  const response = await apiClient.post<IncreasePeriodDto>(
    periodsUrl(organizationId),
    request,
  )
  return response.data
}

export async function getIncreasePeriods(
  organizationId: string,
): Promise<IncreasePeriodSummaryDto[]> {
  const response = await apiClient.get<IncreasePeriodSummaryDto[]>(
    periodsUrl(organizationId),
  )
  return response.data
}

export async function getReportingLineIssues(
  organizationId: string,
  periodId: string,
): Promise<ReportingLineIssuesDto> {
  const response = await apiClient.get<ReportingLineIssuesDto>(
    `${periodsUrl(organizationId)}/${periodId}/reporting-line-issues`,
  )
  return response.data
}

export async function openPeriodToManagers(
  organizationId: string,
  periodId: string,
): Promise<OpenToManagersResultDto> {
  const response = await apiClient.post<OpenToManagersResultDto>(
    `${periodsUrl(organizationId)}/${periodId}/open-to-managers`,
  )
  return response.data
}

export const salaryIncreaseService = {
  getCompanyRules,
  createIncreasePeriod,
  getIncreasePeriods,
  getReportingLineIssues,
  openPeriodToManagers,
}
